import { GetterTree, MutationTree, ActionTree } from 'vuex';
import { RootState } from '@/store'
import Report from '@/models/Ingredient'
import DocumentService from '@/services/DocumentService'
import ingredients from './ingredients';
const documentService = new DocumentService()

export interface ReportState {
  reports: [];
}

const state: ReportState = {
  reports: []
}


const mutations: MutationTree<ReportState> = {
}

const actions: ActionTree<ReportState, any> = {
  async generateDoc({ commit, dispatch, rootState }, product) {
    for (let item of product.ingredients) {
      if (typeof item.id === 'undefined' && typeof item.evaluationId === 'undefined') {
        const evaluation = await dispatch('projectIngredients/hasEvaluation', { projectId: product.projectId, item }, { root: true });
        if (evaluation) {
          item = Object.assign(item, evaluation);
        }
      }
    }

    const item = product;
    item['company'] = rootState.company.company;
    item['user'] = rootState.user.user;

    documentService.generateDoc(item)
  },
}

const getters: GetterTree<ReportState, RootState> = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
